// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amp-layout__wrapper .footer-service__wrapper{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;padding-bottom:20px}.amp-layout__wrapper .footer-service__title{margin-bottom:9px;font-size:14px}.amp-layout__wrapper .footer-service__button.assistant.assistant__button{font-size:14px}", ""]);
// Exports
module.exports = exports;
